import React from 'react';
import { Link } from 'react-router-dom';
import { BrandWordmark } from './BrandWordmark';
import { BRAND_NAME, BRAND_SUBHEAD, DIRECTORY_NAME, NEWSLETTER_NAME, PRIMARY_CITY_NAME, PRIMARY_CITY_SLUG } from '../lib/brand';

const SOCIAL_LINKS = [
  { href: 'https://www.instagram.com/therecoverydirectory', label: 'Instagram' },
  { href: 'https://x.com/recoverydir', label: 'X' },
  { href: 'https://www.linkedin.com/company/the-recovery-directory', label: 'LinkedIn' },
  { href: 'https://www.youtube.com/@therecoverydirectory', label: 'YouTube' },
  { href: 'https://www.facebook.com/therecoverydirectory', label: 'Facebook' },
];

const LINK_SECTIONS = [
  {
    title: 'Quick Links',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Directory', to: '/directory' },
      { label: 'Journal', to: '/journal' },
    ],
  },
  {
    title: 'Need Help?',
    links: [
      { label: `${PRIMARY_CITY_NAME} Venues`, to: `/${PRIMARY_CITY_SLUG}/all` },
{ label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Service', to: '/terms' },
    ],
  },
  {
    title: 'Follow Us',
    links: SOCIAL_LINKS,
  },
] as const;

function FooterLink({ label, to, href }: { label: string; to?: string; href?: string }) {
  const className = 'transition-colors hover:text-brand-charcoal hover:underline underline-offset-4';

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
        {label}
      </a>
    );
  }

  return (
    <Link to={to ?? '/'} className={className}>
      {label}
    </Link>
  );
}

export const Footer = () => {
  return (
    <footer className="section-surface-white border-t border-brand-charcoal/10 px-6 md:px-10 lg:px-16">
      <div className="site-shell">
        <div className="flex flex-col items-start justify-between gap-10 border-b border-brand-charcoal/10 py-10 text-brand-charcoal/60 md:flex-row md:gap-12 md:py-12">
          <div className="max-w-[410px]">
            <div className="mb-5">
              <BrandWordmark
                href="/"
                iconClassName="h-10 w-10 rounded-lg"
              />
            </div>
            <p className="max-w-[410px] text-sm leading-7 text-brand-charcoal/58">
              Home to {DIRECTORY_NAME} and {NEWSLETTER_NAME}. {BRAND_SUBHEAD}
            </p>
          </div>

          <div className="flex w-full flex-wrap justify-between gap-8 md:w-[48%] lg:w-[46%]">
            {LINK_SECTIONS.map((section) => (
              <div key={section.title} className="min-w-[140px]">
                <h3 className="mb-3 text-base font-semibold text-brand-charcoal md:mb-5">{section.title}</h3>
                <ul className="space-y-2 text-sm text-brand-charcoal/58">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <FooterLink label={link.label} to={'to' in link ? link.to : undefined} href={'href' in link ? link.href : undefined} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <p className="py-4 text-center text-sm text-brand-charcoal/52 md:text-base">
          Copyright 2026 © {BRAND_NAME}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
